import React, { useContext, useEffect, useRef, useState } from 'react';
import { Row, Col, Stack } from 'react-bootstrap';
import { useNavigate, useParams } from 'react-router-dom';
import 'assets/styles/common.scss';
import { LocaleContext } from 'routes/Router';
import { FormattedMessage, useIntl } from 'react-intl';
import ServiceLogo from 'assets/images/Dashboard/Logo.png';
import ReusableButton from 'components/common/Button';
import AddBlackColor from 'assets/images/Dashboard/addBlackColor.png';
import CircularProgress from '@mui/material/CircularProgress';
import {
  providerAdminAddService,
  providerAdminAddSubCategory,
  providerAdminEditSubCategory,
  providerAdminViewSubCategory,
} from 'routes/AppUrls';
import ScrollableTabs from 'components/common/SrollableTabs';
import ServiceList from './ServiceList';
import { useDispatch, useSelector } from 'react-redux';
import { getCategoryCallAPI } from 'store/SuperAdmin/getCategory/action';
import { deleteSubCategoryCallAPI } from 'store/SuperAdmin/deleteSubCategory/action';
import ToastNotification from 'components/common/Toast';
import {
  basicDetailsCallApi,
  BASIC_DETAILS,
  SELECTED_TAB,
  SERVICE_DETAILS,
  SUB_CATEGORY_DETAILS,
  REORDERED_SERVICES,
} from 'store/SuperAdmin/basicDetails/action';
import { deleteServiceCallAPI } from 'store/SuperAdmin/deleteService/action';
import { updateEnableDisableServicesCallAPI } from 'store/SuperAdmin/updateEnableDisableService/action';
import { addSubCategoryCallAPI } from 'store/SuperAdmin/addSubCategory/action';
import { massUploadServicesCallAPI } from 'store/ProviderAdmin/massUploadServices/action';
import { ShimmerBox } from 'components/common/Shimmer';
import Lottie from 'lottie-react';
import animationData from 'assets/Lottie/no_data.json';
import { setPageTitle } from 'store/pageTitle/action';

const ProviderCategory = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const intl = useIntl();
  const { locale } = useContext(LocaleContext);
  const [tabData, setTabData] = useState(null);
  const [conf, setConf] = ToastNotification();
  const fileInputRef = useRef();
  const [localServices, setLocalServices] = useState([]);

  const getCategoryData = useSelector((state) => state?.getCategoryReducer);
  const categoryLoading = useSelector(
    (state) => state?.getCategoryReducer?.loading
  );

  const profileData = useSelector((state) => state?.userMeReducer?.data?.data);

  const massUploadLoader = useSelector(
    (state) => state?.massUploadServicesReducer?.loading
  );

  const getselectedTab = useSelector(
    (state) => state?.basicDetailsReducer?.selectedTab
  );
  const selectedCategory = useSelector(
    (state) => state?.basicDetailsReducer?.editCategory
  );
  const [selectedTab, setSelectedTab] = useState(getselectedTab);
  const [isChangingTab, setIsChangingTab] = useState(false);

  const handleTabChange = (newValue) => {
    if (newValue !== selectedTab) {
      setIsChangingTab(true);
      setSelectedTab(newValue);
    }
  };

  useEffect(() => {
    dispatch(setPageTitle('Services'));
    getCategoryList();
  }, []);

  useEffect(() => {
    const selectedCategory =
      getCategoryData.data.data?.length > 0 &&
      getCategoryData.data.data[selectedTab];
    if (selectedCategory) {
      setTabData(selectedCategory);
      dispatch(basicDetailsCallApi(BASIC_DETAILS, selectedCategory));
      dispatch(basicDetailsCallApi(SELECTED_TAB, selectedTab));
      setIsChangingTab(false);
    }
  }, [selectedTab, getCategoryData]);

  const getCategoryList = () => {
    dispatch(
      getCategoryCallAPI(
        {},
        {
          navigate: navigate,
        }
      )
    );
  };

  useEffect(() => {
    if (tabData?.products_list) {
      setLocalServices(tabData.products_list);
    }
  }, [tabData]);

  const handleAddService = (data) => {
    dispatch(basicDetailsCallApi(SERVICE_DETAILS, data));
    navigate(providerAdminAddService(locale));
  };

  const handleEditService = (data) => {
    dispatch(basicDetailsCallApi(SUB_CATEGORY_DETAILS, data));
    navigate(providerAdminEditSubCategory(locale, data.id));
  };

  const handleViewService = (data) => {
    dispatch(basicDetailsCallApi(SUB_CATEGORY_DETAILS, data));
    navigate(providerAdminViewSubCategory(locale, data.id));
  };

  const handleDeleteService = (data) => {
    dispatch(
      deleteSubCategoryCallAPI(
        {},
        {
          id: data?.id,
          navigate: navigate,
          run: true,
          handleFunction: (res) => handleRedirectSubCategory(res, data),
        }
      )
    );
  };

  const handleDeleteSubService = (data) => {
    dispatch(
      deleteServiceCallAPI(
        {},
        {
          id: data?.id,
          navigate: navigate,
          run: true,
          handleFunction: (res) => handleRedirectService(res, selectedCategory),
        }
      )
    );
  };

  const handleRedirectService = (res, data) => {
    setConf({
      msg: res?.data?.message,
      variant: 'error',
    });
    getCategoryList();
  };

  const handleRedirectSubCategory = (res) => {
    setConf({
      msg: res?.data?.message,
      variant: 'error',
    });
    getCategoryList();
  };

  const handleRedirectSuccess = (res) => {
    setConf({
      msg: res?.data?.message,
      variant: 'success',
    });
    getCategoryList();
  };

  const handleEnableDisableCheckBox = (data, category) => {
    let body = {
      service_id: data?.id,
      is_status: !data?.is_public,
    };
    dispatch(
      updateEnableDisableServicesCallAPI(body, {
        run: true,
        handleFunction: (res) => {
          handleRedirectSuccess(res);
          handleCopyServicesData(data, category);
        },
        navigate: navigate,
        toast: true,
        handleToastError: (res) => handleRedirectError(res),
      })
    );
  };

  const handleCopyServicesData = (service, category) => {
    console.log(service, locale, 'jhjdfgd');
    if (!service?.provider_product_admin) {
      const body = {
        master_category_id: category?.category_id,
        admin_product_id: service?.id,
        name_en: locale === 'en' ? service?.product_name : null,
        title_ar: locale === 'ar' ? service?.product_name : null,
        time_required_in_mints: service?.time_required_in_mints,
        price: service?.price,
        currency: service?.currency,
      };

      dispatch(
        addSubCategoryCallAPI(body, {
          run: true,
          handleFunction: (res) => handleRedirectSuccess(res),
          navigate: navigate,
          toast: true,
          handleToastError: (res) => handleRedirectError(res),
        })
      );
    }
  };

  const handleReorderServices = (reorderedServices) => {
    if (tabData && reorderedServices?.length > 0) {
      dispatch(basicDetailsCallApi(REORDERED_SERVICES, reorderedServices));
    }
  };

  const handleRedirectError = (res) => {
    setConf({
      msg: res?.data?.message,
      variant: 'error',
    });
  };

  const handleChooseFile = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  const handleFileUpload = (e) => {
    if (e.target.files[0]) {
      let formData = new FormData();
      formData.append('file', e.target.files[0]);
      dispatch(
        massUploadServicesCallAPI(formData, {
          navigate: navigate,
          run: true,
          handleFunction: (res) => {
            handleRedirectSuccess(res);
            if (fileInputRef.current) {
              fileInputRef.current.value = '';
            }
          },
          toast: true,
          handleToastError: (res) => {
            handleRedirectError(res);
            if (fileInputRef.current) {
              fileInputRef.current.value = '';
            }
          },
        })
      );
    }
  };

  return (
    <Row className="bc-F2F3F6 m-0 p-0">
      <Col
        className={
          locale === 'en'
            ? 'commonEnContainer lg:ml-left'
            : 'commonArContainer lg:mr-right'
        }
      >
        <Row className="bc-FFFFFF m-0 p-16 mt-3">
          <div className="flex justify-between items-center">
            {/* <h2 className="fc-292D32 fs-32 fw-400 ff-Akkurat_Bold m-0">
              <FormattedMessage id="Services" />
            </h2> */}
          </div>

          {categoryLoading ? (
            <>
              <Row className="mt-4 m-0 p-0">
                <ShimmerBox width="150px" height="24px" />
              </Row>
              <Row className="m-0 p-0 mt-3">
                <Col md={12}>
                  <div className="flex gap-2">
                    {[1, 2, 3, 4].map((item) => (
                      <ShimmerBox
                        key={item}
                        width="120px"
                        height="44px"
                        style={{ borderRadius: '4px' }}
                      />
                    ))}
                  </div>
                </Col>
              </Row>
              <Row className="m-0 p-0 mt-4">
                <div className="flex justify-between items-center w-100">
                  <ShimmerBox width="200px" height="32px" />
                  <Stack
                    direction="horizontal"
                    gap={4}
                    className="items-center"
                  >
                    <ShimmerBox width="150px" height="44px" />
                    <ShimmerBox width="180px" height="44px" />
                  </Stack>
                </div>
              </Row>
              <Row className="m-0 p-0 mt-3">
                {[1, 2, 3, 4].map((item) => (
                  <Row
                    key={item}
                    className="m-0 p-0 items-center border-b py-4"
                  >
                    <Col md={6}>
                      <div className="flex items-center gap-2">
                        <ShimmerBox width="32px" height="32px" />
                        <ShimmerBox width="32px" height="32px" />
                        <ShimmerBox width="200px" height="16px" />
                      </div>
                    </Col>
                    <Col md={3}></Col>
                    <Col md={3}>
                      <div className="flex justify-end">
                        <ShimmerBox width="24px" height="24px" />
                      </div>
                    </Col>
                  </Row>
                ))}
              </Row>
            </>
          ) : getCategoryData?.data?.data?.length > 0 ? (
            <>
              <Row className="mt-4 m-0 p-0">
                <div className="flex  items-center">
                  <h2 className="fc-292D32 fs-24 fw-400 ff-Akkurat_Bold m-0">
                    <FormattedMessage id="Categories" />
                  </h2>
                </div>
              </Row>

              <Row className="m-0 p-0">
                <Col md={12}>
                  <ScrollableTabs
                    tabs={getCategoryData.data.data.map((items, index) => ({
                      label: items?.category_name,
                      icon: items?.category_icon,
                    }))}
                    onTabChange={handleTabChange}
                    initialTab={selectedTab}
                  />
                </Col>
              </Row>
              {getCategoryData.data.data.map(
                (items, index) =>
                  tabData?.category_id === items?.category_id && (
                    <>
                      <Row className="m-0 p-0 mt-4">
                        <div className="flex justify-between items-center">
                          <h2 className="fc-292D32 fs-32 fw-400 ff-Akkurat_Bold m-0">
                            {items?.category_name}
                          </h2>
                          {!profileData?.provider_details?.is_under_sallon && (
                            <Stack
                              direction="horizontal"
                              gap={4}
                              className="items-center "
                            >
                              <input
                                ref={fileInputRef}
                                type="file"
                                accept=".csv, .xlsx"
                                disabled={false}
                                style={{ display: 'none' }}
                                onChange={handleFileUpload}
                              />
                              <ReusableButton
                                fullWidth={false}
                                variant="outlined"
                                color="#000000"
                                fontSize="16px"
                                fontWeight="400"
                                padding="12px 25px"
                                height="44px"
                                bgColor="transparent"
                                brColor="#DDDDDD"
                                fontFamily="Akkurat"
                                onClick={handleChooseFile}
                                endIcon={
                                  massUploadLoader && (
                                    <CircularProgress
                                      style={{
                                        color: '#000000',
                                        width: '20px',
                                        height: '20px',
                                      }}
                                    />
                                  )
                                }
                              >
                                <img
                                  src={AddBlackColor}
                                  alt="icon"
                                  style={{ height: '24px', width: '24px' }}
                                  className="me-2"
                                />
                                <FormattedMessage id="Bulk Import" />
                              </ReusableButton>
                              <ReusableButton
                                fullWidth={false}
                                variant="outlined"
                                color="#000000"
                                fontSize="16px"
                                fontWeight="400"
                                padding="12px 25px"
                                height="44px"
                                bgColor="transparent"
                                brColor="#DDDDDD"
                                fontFamily="Akkurat"
                                onClick={() =>
                                  navigate(providerAdminAddSubCategory(locale))
                                }
                              >
                                <img
                                  src={AddBlackColor}
                                  alt="icon"
                                  style={{ height: '24px', width: '24px' }}
                                  className="me-2"
                                />
                                <FormattedMessage id="Add Sub-Category" />
                              </ReusableButton>
                            </Stack>
                          )}
                        </div>
                      </Row>

                      {isChangingTab ? (
                        <Row className="m-0 p-0 mt-3">
                          {[1, 2, 3, 4].map((item) => (
                            <Row
                              key={item}
                              className="m-0 p-0 items-center border-b py-4"
                            >
                              <Col md={6}>
                                <div className="flex items-center gap-2">
                                  <ShimmerBox width="32px" height="32px" />
                                  <ShimmerBox width="32px" height="32px" />
                                  <ShimmerBox width="200px" height="16px" />
                                </div>
                              </Col>
                              <Col md={3}></Col>
                              <Col md={3}>
                                <div className="flex justify-end">
                                  <ShimmerBox width="24px" height="24px" />
                                </div>
                              </Col>
                            </Row>
                          ))}
                        </Row>
                      ) : items?.products_list?.length > 0 ? (
                        <Row className="m-0 p-0 mt-2">
                          <ServiceList
                            services={localServices}
                            loading={categoryLoading}
                            onEdit={(data) => handleEditService(data)}
                            onDelete={(data) => handleDeleteService(data)}
                            onCheckBoxEnableDisable={(data) =>
                              handleEnableDisableCheckBox(data, items)
                            }
                            onDeleteSubService={(data) =>
                              handleDeleteSubService(data)
                            }
                            onReadOnly={
                              profileData?.provider_details?.is_under_sallon
                            }
                            onView={(data) => handleViewService(data)}
                            // onCopyServicesData={(service) =>
                            //   handleCopyServicesData(service, items)
                            // }
                            onAddService={(data) => handleAddService(data)}
                            onReorder={(reorderedServices) => {
                              setLocalServices(reorderedServices);
                              handleReorderServices(reorderedServices);
                            }}
                          />
                        </Row>
                      ) : (
                        <Row className="m-0 p-0 mt-3 flex justify-center">
                          <Lottie
                            animationData={animationData}
                            loop={true}
                            style={{ height: '200px', width: '200px' }}
                          />
                        </Row>
                      )}
                    </>
                  )
              )}
            </>
          ) : (
            <Row className="mt-5 pt-5 text-center">
              <p className="fc-292D32 fs-16 fw-400 ff-Akkurat m-0">
                <FormattedMessage id="No category added" />
              </p>
            </Row>
          )}
        </Row>
      </Col>
    </Row>
  );
};

export default ProviderCategory;
